export const th = {
  // Common
  common: {
    loading: 'กำลังโหลด...',
    error: 'ข้อผิดพลาด',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    delete: 'ลบ',
    edit: 'แก้ไข',
    add: 'เพิ่ม',
    search: 'ค้นหา',
    back: 'กลับ',
    close: 'ปิด',
    confirm: 'ยืนยัน',
    yes: 'ใช่',
    no: 'ไม่',
    ok: 'ตกลง',
    submit: 'ส่ง',
    reset: 'รีเซ็ต',
    clear: 'ล้าง',
    view: 'ดู',
    details: 'รายละเอียด',
    settings: 'ตั้งค่า',
    logout: 'ออกจากระบบ',
    login: 'เข้าสู่ระบบ',
    signup: 'สมัครสมาชิก',
    profile: 'โปรไฟล์',
    collection: 'คอลเลกชัน',
    insights: 'ข้อมูลเชิงลึก',
    overview: 'ภาพรวม',
    categories: 'หมวดหมู่',
    preorders: 'สั่งจองล่วงหน้า',
    recent: 'ล่าสุด',
    total: 'รวม',
    average: 'เฉลี่ย',
    price: 'ราคา',
    quantity: 'จำนวน',
    author: 'ผู้เขียน',
    publisher: 'สำนักพิมพ์',
    isbn: 'ISBN',
    genre: 'ประเภท',
    type: 'ชนิด',
    language: 'ภาษา',
    source: 'แหล่งที่มา',
    date: 'วันที่',
    status: 'สถานะ',
    value: 'มูลค่า',
    items: 'รายการ',
    owned: 'เป็นเจ้าของ',
    preorder: 'สั่งจองล่วงหน้า',
    created: 'สร้างเมื่อ',
    updated: 'อัปเดตเมื่อ',
    title: 'ชื่อเรื่อง',
    description: 'คำอธิบาย',
    image: 'รูปภาพ',
    currency: 'สกุลเงิน',
    preferences: 'การตั้งค่า',
    clone: 'คัดลอก',
    cloneSuccess: 'คัดลอกหนังสือสำเร็จแล้ว',
    cloneError: 'ไม่สามารถคัดลอกหนังสือได้',
    code: 'รหัส'
  },

  // Navigation
  nav: {
    home: 'หน้าแรก',
    collection: 'คอลเลกชัน',
    insights: 'ข้อมูลเชิงลึก',
    wishlist: 'รายการที่ต้องการ',
    settings: 'ตั้งค่า',
    profile: 'โปรไฟล์',
    logout: 'ออกจากระบบ',
    language: 'ภาษา'
  },

  // Landing Page
  landing: {
    title: 'BookPort',
    subtitle: 'เครื่องมือจัดการคอลเลกชันหนังสือส่วนตัวของคุณ',
    description: 'จัดระเบียบ ติดตาม และจัดการคอลเลกชันหนังสือของคุณได้อย่างง่ายดาย ตั้งแต่นวนิยายไปจนถึงหนังสือเรียน เก็บทุกอย่างไว้ในที่ที่สวยงามและเป็นระเบียบ',
    getStarted: 'เริ่มต้น',
    signUp: 'สมัครสมาชิก',
    goToCollection: 'ไปที่คอลเลกชัน',
    sampleCollection: 'คอลเลกชันตัวอย่าง',
    features: {
      title: 'คุณสมบัติที่ทรงพลัง',
      subtitle: 'ทุกสิ่งที่คุณต้องการเพื่อจัดการคอลเลกชันหนังสือของคุณ',
      completeManagement: {
        title: 'การจัดการหนังสือที่สมบูรณ์',
        description: 'จัดระเบียบคอลเลกชันหนังสือทั้งหมดของคุณด้วยข้อมูลที่ละเอียดรวมถึงผู้เขียน สำนักพิมพ์ ประเภท และอื่นๆ'
      },
      smartSearch: {
        title: 'การค้นหาอัจฉริยะ',
        description: 'ค้นหาหนังสือใดๆ ในคอลเลกชันของคุณได้ทันทีด้วยการค้นหาที่ทรงพลังตามชื่อเรื่อง ผู้เขียน ISBN หรือสำนักพิมพ์'
      },
      multiCurrency: {
        title: 'หลายสกุลเงิน',
        description: 'ติดตามมูลค่าหนังสือในสกุลเงินที่คุณต้องการด้วยการอัปเดตอัตราแลกเปลี่ยนอัตโนมัติ'
      },
      bookTracking: {
        title: 'การติดตามหนังสือ',
        description: 'ติดตามความคืบหน้าในการอ่าน สภาพหนังสือ และการเติบโตของคอลเลกชันเมื่อเวลาผ่านไป'
      },
      cloudSync: {
        title: 'การซิงค์คลาวด์',
        description: 'เข้าถึงคอลเลกชันหนังสือของคุณจากที่ไหนก็ได้ด้วยการซิงค์คลาวด์ที่ปลอดภัย'
      },
      secure: {
        title: 'ปลอดภัยและเป็นส่วนตัว',
        description: 'ข้อมูลคอลเลกชันหนังสือของคุณเป็นส่วนตัวและปลอดภัยด้วยการเข้ารหัสระดับองค์กร'
      }
    },
    howItWorks: {
      title: 'วิธีการทำงาน',
      subtitle: 'เริ่มต้นในไม่กี่ขั้นตอนง่ายๆ',
      signUp: {
        title: 'สมัครสมาชิก',
        description: 'สร้างบัญชีฟรีของคุณในไม่กี่วินาที'
      },
      addBooks: {
        title: 'เพิ่มหนังสือ',
        description: 'เพิ่มหนังสือของคุณด้วยข้อมูลที่ละเอียด'
      },
      organize: {
        title: 'จัดระเบียบ',
        description: 'จัดระเบียบตามประเภท ผู้เขียน หรือเกณฑ์ใดก็ได้'
      },
      monitor: {
        title: 'ติดตาม',
        description: 'ติดตามการเติบโตและมูลค่าของคอลเลกชันของคุณ'
      }
    },
    benefits: {
      title: 'ทำไมต้องเลือก BookPort?',
      subtitle: 'เข้าร่วมกับคนรักหนังสือหลายพันคนที่ไว้วางใจ BookPort ในการจัดการคอลเลกชันของพวกเขา',
      neverLose: 'ไม่เคยสูญเสียการติดตามหนังสือของคุณอีกครั้ง',
      trackValue: 'ติดตามมูลค่าของคอลเลกชันของคุณ',
      planPurchases: 'วางแผนการซื้อหนังสือครั้งต่อไปของคุณ',
      shareCollection: 'แบ่งปันคอลเลกชันของคุณกับเพื่อน',
      mobileFriendly: 'เข้าถึงจากอุปกรณ์ใดก็ได้',
      freeToUse: 'ใช้งานฟรีโดยไม่มีค่าใช้จ่าย'
    },
    readerTypes: {
      title: 'เหมาะสำหรับผู้อ่านทุกประเภท',
      description: 'ไม่ว่าคุณจะสะสมนวนิยาย หนังสือเรียน การ์ตูน หรือหนังสือหายาก BookPort ปรับตัวให้เข้ากับสไตล์การสะสมของคุณ',
      startCollection: 'เริ่มคอลเลกชันของคุณ'
    },
    cta: {
      title: 'พร้อมที่จะจัดระเบียบหนังสือของคุณแล้วหรือยัง?',
      subtitle: 'เข้าร่วมกับคนรักหนังสือหลายพันคนที่จัดระเบียบคอลเลกชันของพวกเขาด้วย BookPort แล้ว',
      createAccount: 'สร้างบัญชี'
    }
  },

  // Collection
  collection: {
    title: 'คอลเลกชันหนังสือของฉัน',
    addNewBook: 'เพิ่มหนังสือใหม่',
    addBook: 'เพิ่มหนังสือ',
    searchPlaceholder: 'ค้นหาตามชื่อเรื่อง ผู้เขียน ISBN หรือสำนักพิมพ์...',
    noBooks: 'ยังไม่มีหนังสือในคอลเลกชันของคุณ',
    noSearchResults: 'ไม่พบหนังสือที่ตรงกับการค้นหาของคุณ',
    addFirstBook: 'เพิ่มหนังสือเล่มแรกของคุณ',
    startBuildingCollection: 'เริ่มสร้างคอลเลกชันของคุณโดยการเพิ่มหนังสือเล่มแรก!',
    tryAdjustingSearch: 'ลองปรับเงื่อนไขการค้นหาของคุณ',
    showingResults: 'แสดง {count} จาก {total} เล่ม',
    endOfResults: 'คุณได้ถึงจุดสิ้นสุดของคอลเลกชันแล้ว',
    summary: {
      title: 'ติดตามและจัดระเบียบคอลเลกชันหนังสืออันมีค่าของคุณ',
      totalBooks: 'หนังสือทั้งหมด',
      foundBooks: 'หนังสือที่พบ',
      totalValue: 'มูลค่ารวม',
      averagePrice: 'ราคาเฉลี่ย',
      totalQuantity: 'จำนวนรวม'
    }
  },

  // Book Detail
  bookDetail: {
    newBook: 'เพิ่มหนังสือใหม่',
    editBook: 'แก้ไขหนังสือ',
    title: 'ชื่อเรื่อง',
    author: 'ผู้เขียน',
    isbn: 'ISBN',
    publisher: 'สำนักพิมพ์',
    series: 'ซีรีส์',
    genre: 'ประเภท',
    type: 'ชนิด',
    language: 'ภาษา',
    price: 'ราคา',
    quantity: 'จำนวน',
    source: 'แหล่งที่มา',
    imageUrl: 'URL รูปภาพ',
    createdDate: 'วันที่สร้าง',
    notes: 'บันทึก',
    save: 'บันทึกหนังสือ',
    cancel: 'ยกเลิก',
    delete: 'ลบหนังสือ',
    deleteConfirm: 'คุณแน่ใจหรือไม่ที่จะลบหนังสือนี้?',
    deleteConfirmDescription: 'การดำเนินการนี้ไม่สามารถยกเลิกได้',
    imagePlaceholder: 'ไม่มีรูปภาพ'
  },

  // Insights
  insights: {
    title: 'ข้อมูลเชิงลึกของคอลเลกชัน',
    subtitle: 'การวิเคราะห์และข้อมูลเชิงลึกแบบละเอียดเกี่ยวกับคอลเลกชันหนังสือของคุณ',
    overview: {
      title: 'ภาพรวม',
      collectionStatus: 'สถานะคอลเลกชัน',
      ownedItems: 'รายการที่เป็นเจ้าของ',
      preorderItems: 'รายการสั่งจองล่วงหน้า',
      valueBreakdown: 'การแบ่งมูลค่า',
      ownedValue: 'มูลค่าที่เป็นเจ้าของ',
      preorderValue: 'มูลค่าสั่งจองล่วงหน้า',
      mostValuableItems: 'รายการที่มีมูลค่าสูงสุด'
    },
    categories: {
      title: 'หมวดหมู่',
      topPublishers: 'สำนักพิมพ์ยอดนิยม',
      topGenres: 'ประเภทยอดนิยม',
      topTypes: 'ชนิดยอดนิยม',
      topLanguages: 'ภาษายอดนิยม',
      topSources: 'แหล่งที่มายอดนิยม'
    },
    preorders: {
      title: 'สั่งจองล่วงหน้า',
      preorderSummary: 'สรุปการสั่งจองล่วงหน้า',
      items: 'รายการ',
      totalValue: 'มูลค่ารวม'
    },
    recent: {
      title: 'ล่าสุด',
      recentAdditions: 'รายการที่เพิ่มล่าสุด'
    },
    stats: {
      totalItems: 'รายการทั้งหมด',
      totalValue: 'มูลค่ารวม',
      totalQuantity: 'จำนวนรวม',
      averagePrice: 'ราคาเฉลี่ย'
    }
  },

  // Settings
  settings: {
    title: 'ตั้งค่าผู้ใช้',
    currency: 'สกุลเงิน',
    language: 'ภาษา',
    saveSettings: 'บันทึกการตั้งค่า',
    settingsSaved: 'บันทึกการตั้งค่าสำเร็จ!',
    settingsError: 'ไม่สามารถบันทึกการตั้งค่าได้',
    currencyDescription: 'ตั้งค่าสกุลเงินที่คุณต้องการสำหรับแสดงราคาในแอปพลิเคชัน ราคาทั้งหมดจะถูกแปลงเป็นสกุลเงินที่คุณเลือก',
    languageDescription: 'เลือกภาษาที่คุณต้องการสำหรับอินเทอร์เฟซแอปพลิเคชัน ภาษาจะถูกใช้ทันที',
    preferences: 'การตั้งค่า'
  },

  // Auth
  auth: {
    login: {
      title: 'เข้าสู่ระบบ BookPort',
      email: 'อีเมล',
      password: 'รหัสผ่าน',
      signIn: 'เข้าสู่ระบบ',
      signInWithGoogle: 'เข้าสู่ระบบด้วย Google',
      noAccount: 'ยังไม่มีบัญชี?',
      signUp: 'สมัครสมาชิก',
      forgotPassword: 'ลืมรหัสผ่าน?',
      loginError: 'ไม่สามารถเข้าสู่ระบบได้'
    },
    signup: {
      title: 'สร้างบัญชีของคุณ',
      displayName: 'ชื่อที่แสดง',
      email: 'อีเมล',
      password: 'รหัสผ่าน',
      confirmPassword: 'ยืนยันรหัสผ่าน',
      signUp: 'สมัครสมาชิก',
      signUpWithGoogle: 'สมัครสมาชิกด้วย Google',
      haveAccount: 'มีบัญชีอยู่แล้ว?',
      signIn: 'เข้าสู่ระบบ',
      signupError: 'ไม่สามารถสร้างบัญชีได้',
      passwordMismatch: 'รหัสผ่านไม่ตรงกัน'
    }
  },

  // Languages
  languages: {
    en: 'English',
    th: 'ไทย',
    ja: '日本語',
    zh: '中文'
  },

  // Wishlist
  wishlist: {
    title: 'รายการที่ต้องการ',
    subtitle: 'ติดตามหนังสือที่คุณต้องการเพิ่มในคอลเลกชัน',
    addNewWish: 'เพิ่มรายการที่ต้องการ',
    addFirstWish: 'เพิ่มรายการที่ต้องการแรกของคุณ',
    searchPlaceholder: 'ค้นหารายการในรายการที่ต้องการ...',
    noWishItems: 'ยังไม่มีรายการในรายการที่ต้องการของคุณ',
    noSearchResults: 'ไม่พบรายการในรายการที่ต้องการที่ตรงกับการค้นหาของคุณ',
    showingResults: 'แสดง {count} จาก {total} รายการ',
    convertToBook: 'แปลงเป็นหนังสือ',
    convert: 'ใช่ ฉันได้มาแล้ว!',
    converting: 'กำลังแปลง...',
    convertConfirm: 'คุณได้มาแล้วหรือยัง?',
    convertConfirmDescription: 'นี่จะย้ายรายการนี้จากรายการที่ต้องการไปยังคอลเลกชันของคุณ คุณสามารถเพิ่มข้อมูลจำนวนและแหล่งที่มาได้หลังจากนั้น',
    deleteConfirm: 'ลบรายการที่ต้องการ?',
    deleteConfirmDescription: 'นี่จะลบรายการที่ต้องการนี้อย่างถาวร การดำเนินการนี้ไม่สามารถยกเลิกได้',
    // New celebratory conversion messages
    congratulations: '🎉 ยินดีด้วย! 🎉',
    finallyGotIt: 'ในที่สุดก็ได้มาแล้วสินะ!',
    thatsAwesome: 'สุดยอดเลย! 🎊 ตอนนี้ถึงเวลาแล้วที่จะย้ายหนังสือสวยๆ เล่มนี้จากรายการที่อยากได้ไปเป็นของในคอลเลกชันแล้ว คุณจะเพิ่มข้อมูลอื่นๆ เช่นจำนวนและที่ซื้อมาได้ด้วย',
    readyToCelebrate: 'พร้อมจะเฉลิมฉลองการได้หนังสือใหม่แล้วหรือยัง?',
    maybeLater: 'ไว้ก่อนนะ',
    yesAddToCollection: '🎉 ใช่เลย! เพิ่มในคอลเลกชัน!',
    addingToCollection: 'กำลังเพิ่มในคอลเลกชัน...'
  },

  // Currencies
  currencies: {
    USD: 'ดอลลาร์สหรัฐ',
    THB: 'บาทไทย',
    JPY: 'เยนญี่ปุ่น',
    CNY: 'หยวนจีน'
  },


}; 